var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"way__half-card",on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-img',{style:({
      borderRadius: '2px',
    }),attrs:{"aspect-ratio":"1.26","src":_vm.src}}),_c('p',{staticClass:"mt-16 mb-24"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }